'use strict';

var angular = require('angular');

module.exports = function($scope, $http, $location, $timeout, ngAudio) {
    $scope.currentCharacter = {};
    $scope.showDefaultOptions = false;
    $scope.pauseAnimation = false;
    $scope.currentProducts = [];

    var easterActive = false,
        timedStateChange = null;

    $scope.sound = {
        approve: ngAudio.load("/audio/cash-register.mp3"),
        deny: ngAudio.load("/audio/deny.mp3"),
        button: ngAudio.load("/audio/plop1.mp3"),
        click: ngAudio.load('/audio/click.mp3')
    };

    $scope.sound.click.volume = 0.3;
    $scope.sound.deny.volume = 0.75;

    $http.get('/api/game/start')
        .then(function(response) {
            var data = response.data;

            if (data.noPreQuiz) {
                return $location.path('/prequiz');
            }

            buildState(data, false);
            $scope.gotoProducts(true);
        });

    $scope.chooseOption = function(optionId) {
        $scope.sound.click.play();

        if (optionId == 'showProducts') {
            $scope.gotoProducts();
            return;
        }

        var finish = $scope.currentCharacter.next === 'finish';

        $http.post('/api/game/choose-option', {
            characterId: $scope.currentCharacter.id,
            stateId: $scope.currentCharacter.stateId,
            optionId: optionId
        })
        .then(function(response) {
            buildState(response.data, finish);
        });
    }

    $scope.approve = function() {
        if (!$scope.showDefaultOptions) {
            return;
        }

        $scope.sound.approve.play();

        $http.post('api/game/approve-character', { characterId: $scope.currentCharacter.id })
            .then(function(response) {
                buildState(response.data);
            })
    }

    $scope.deny = function() {
        if (!$scope.showDefaultOptions) {
            return;
        }

        $scope.sound.deny.play();

        $http.post('api/game/deny-character', { characterId: $scope.currentCharacter.id })
            .then(function(response) {
                buildState(response.data);
            })
    }

    $scope.checkId = function() {
        $scope.sound.click.play();

        if ($scope.currentCharacter.checkId.next) {
            return changeState($scope.currentCharacter.checkId.next);
        }

        $http.post('/api/game/checked-id', { characterId: $scope.currentCharacter.id });

        $scope.currentCharacter.popup = {
            image: $scope.currentCharacter.checkId.image,
            generatedImage: $scope.currentCharacter.checkId.generatedImage,
            next: $scope.currentCharacter.afterId || $scope.currentCharacter.stateId
        };
    }

    $scope.closePopup = function() {
        $scope.sound.click.play();

        if ($scope.currentCharacter.popup.next !== undefined) {
            return changeState($scope.currentCharacter.popup.next);
        }

        $scope.currentCharacter.popup = null;
    }

    $scope.gotoProducts = function(noAnimate) {
        $scope.sound.click.play();

        var mainWindow = document.getElementById('main-window'),
            products = document.getElementById('products'),
            windowHeight = mainWindow.clientHeight;


        mainWindow.style.transform = 'translate3d(0, -100%, 0)';
        mainWindow.style.webkitTransform = 'translate3d(0, -100%, 0)';
        mainWindow.style.msTransform = 'translate(0, -100%)';
        products.style.transform = 'translate3d(0, -100%, 0)';
        products.style.webkitTransform = 'translate3d(0, -100%, 0)';
        products.style.msTransform = 'translate(0, -100%)';
    }

    $scope.gotoTill = function() {
        $scope.sound.click.play();

        var mainWindow = document.getElementById('main-window'),
            products = document.getElementById('products');

            mainWindow.style.transform = 'translate3d(0, 0%, 0)';
            mainWindow.style.webkitTransform = 'translate3d(0, 0%, 0)';
            mainWindow.style.msTransform = 'translate(0, 0%)';
            products.style.transform = 'translate3d(0, 0%, 0)';
            products.style.webkitTransform = 'translate3d(0, 0%, 0)';
            products.style.msTransform = 'translate(0, 0%)';

        
        // Set up countdown to automatically change state
        if ($scope.currentCharacter.timedState && !timedStateChange && $scope.currentCharacter.timedState.state != $scope.currentCharacter.id) {
            timedStateChange = $timeout(function() {
                changeState($scope.currentCharacter.timedState.state);
                timedStateChange = null;
            }, $scope.currentCharacter.timedState.delay || 5000);
        }
    }

    $scope.buttonClick = function(state) {
        $scope.sound.click.play();

        changeState(state);
    }

    /**
     * Set up a character state, based on state data.
     */
    function buildState(state, finish) {
        if (state.gameOver === true) {
            $location.path('/end');
        }

        if (finish) {
            changeState('finish');
        }

        if (!state.popup && state.options === undefined && state.button === undefined && state.next !== undefined) {
            $scope.showDefaultOptions = false;

            $timeout(function() {
                changeState(state.next);
            }, $scope.currentCharacter.timeout ? $scope.currentCharacter.timeout : 2500);
        }
        else {
            $scope.showDefaultOptions = !state.button && !state.popup && state.stateId != 'approved' && state.stateId != 'denied';
        }

        $scope.currentCharacter = state;
        $scope.currentProducts = state.products;

        // Limit products to enabled range
        if (state.productsEnabled) {
            var products = [];

            for (var i=0; i<state.productsEnabled.length; i++) {
                products.push(state.products[state.productsEnabled[i]]);
            }

            $scope.currentProducts = products;
        }

        if ($scope.currentCharacter.options !== undefined) {
            var options = $scope.currentCharacter.options,
                newOptions = [],
                i,
                j;

            for (i=0; i<options.length; i++) {
                options[i].id = i;
            }

            for (i=0, j=options.length; i<j; i+=2) {
                newOptions.push(options.slice(i, i+2));
            }

            $scope.currentCharacter.options = newOptions;
        }

        if (state.preload !== undefined) {
            preloadImages(state.preload);
        }
    }

    $scope.easterTrigger = function() {
        if ($scope.currentCharacter.easterEgg !== undefined) {
            if (!$scope.tillOpen) {
                $scope.tillOpen = true;
            }
            else if (!easterActive) {
                $scope.currentCharacter.popup = $scope.currentCharacter.easterEgg.popup;
                easterActive = true;
            }
            else {
                $scope.tillOpen = false;
                easterActive = false;
            }
        }
    }

    /**
     * Go to a different state.
     */
    function changeState(stateId) {
        if (stateId === 'finish') {
            $http.get('/api/game/next-character')
                .then(function(response) {
                    $scope.gotoProducts(true);
                    buildState(response.data);
                });

            return;
        }

        $http.get('/api/game/state/' + $scope.currentCharacter.id + '/' + stateId)
            .then(function(response) {
                buildState(response.data);
            });
    }

    function preloadImages(load) {
        angular.forEach(load, function(preload) {
            if (preload.products) {
                angular.forEach(preload.products, function(image) {
                    preloadImage('/images/sprites/products/' + image);
                });
            }

            if (preload.states) {
                angular.forEach(preload.states, function(image) {
                    preloadImage('/images/sprites/customers/' + preload.characterId + '/' + image);
                });
            }

            if (preload.ids) {
                angular.forEach(preload.ids, function(id) {
                    if (id.type == 'image') {
                        preloadImage('/images/sprites/customers/' + preload.characterId + '/' + id.url);
                    }
                    else if (id.type == 'generatedImage') {
                        preloadImage(id.url);
                    }
                });
            }
        });
    }

    function preloadImage(url) {
        $http.get(url);
    }
};
